import { render, staticRenderFns } from "./FixItDialog.vue?vue&type=template&id=53fd7d5c"
import script from "./FixItDialog.vue?vue&type=script&lang=js"
export * from "./FixItDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports